<template>
    <div class="seller-o2o-index">
        <div class="common-header-wrap">
            <mt-header title="达达门店" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <mt-cell title="门店编码" :value="dadaInfo.origin_shop_id"></mt-cell>
        <mt-cell title="门店状态" :value="dadaInfo.status?'激活':'下线'"></mt-cell>
        <mt-field label="门店名称" type="text" v-model="dadaInfo.station_name" />
        <div @click="showBusiness=true;"><mt-cell title="业务类型" :value="dadaInfo.business_text" is-link></mt-cell></div>
        <mt-field label="城市名称" type="text" v-model="cityName" />
        <mt-field label="区域名称" type="text" v-model="dadaInfo.area_name" />
        <mt-cell class="input-wrap" title="门店地址"><input type="text" v-model="dadaInfo.station_address" @change="searchMap(false)"><i class="iconfont" @click="showMap=true;">&#xe6d3;</i></mt-cell>
        <mt-field label="联系人姓名" type="text" v-model="dadaInfo.contact_name" />
        <mt-field label="联系人电话" type="text" v-model="dadaInfo.phone" />
        <mt-button class="ds-button-large mt-10" type="primary" size="large" v-on:click="submit">保存</mt-button>
        <mt-popup v-model="showBusiness" position="bottom">
            <mt-picker ref="business_picker" :slots="businessOptions" valueKey="text" showToolbar>
                <div class="toolbar">
                    <button class="toolbar-item cancel-item" @click="showBusiness=false">取消</button>
                    <div class="picker-header">业务类型</div>
                    <button class="toolbar-item confirm-item" @click="confirmBusiness">确定</button>
                </div>
            </mt-picker>
        </mt-popup>
        <mt-popup v-model="showCity" position="bottom">
            <mt-picker ref="city_picker" :slots="cityOptions" valueKey="cityName" showToolbar>
                <div class="toolbar">
                    <button class="toolbar-item cancel-item" @click="showCity=false">取消</button>
                    <div class="picker-header">城市名称</div>
                    <button class="toolbar-item confirm-item" @click="confirmCity">确定</button>
                </div>
            </mt-picker>
        </mt-popup>
        <mt-popup v-model="showMap" position="right" class="common-popup-wrapper">

            <div v-if="dadaInfo.lng && dadaInfo.lat" class="common-popup-content">
                <gaode-map ref="myMap" :longitude="dadaInfo.lng" :latitude="dadaInfo.lat" :ifComponent="true" @setPostion="setPostion" @closeMap="closeMap"></gaode-map>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { getDadaShop, saveDadaShop } from '../../../api/sellerDadaShop'
import { Toast } from 'mint-ui'
import GaodeMap from '../../GaodeMap'
export default {
  name: 'SellerDadaShop',
  components: { GaodeMap },
  data () {
    return {
      dadaInfo: {},
      cityName: '',
      showBusiness: false,
      showMap: false,
      businessOptions: [],
      cityOptions: [],
      showCity: false,
      cityCode: [],
      myTime: false
    }
  },
  created: function () {
    getDadaShop().then(res => {
      this.dadaInfo = res.result.dada_info
      this.cityName = this.dadaInfo.city_name
      this.$nextTick(() => {
        if (this.dadaInfo.station_address) {
          this.searchMap(true)
        }
      })
      this.cityCode = res.result.city_code
      var businessList = res.result.business_list

      var businessOptions = []
      for (var i in businessList) {
        businessOptions.push({ id: i, text: businessList[i] })
      }
      this.businessOptions = [{
        flex: 1,
        values: businessOptions,
        textAlign: 'center'

      }]
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {

  },
  watch: {
    cityName: function (newValue, oldValue) {
      if (oldValue && newValue) {
        clearTimeout(this.myTime)
        this.myTime = setTimeout(() => {
          this.searchCity()
        }, 500)
      }
    }
  },
  methods: {
      closeMap(){
          this.showMap=false
      },
    searchMap (ifInit = false) {
      this.$refs.myMap.searchAddress(this.dadaInfo.station_address, ifInit)
    },
    searchCity () {
      this.dadaInfo.dada_city_code = ''
      var cityOptions = []
      for (var i in this.cityCode) {
        if (this.cityCode[i].cityName.search(this.cityName) != -1) {
          cityOptions.push(this.cityCode[i])
        }
      }
      if (cityOptions.length > 1) {
        this.cityOptions = [{
          flex: 1,
          values: cityOptions,
          textAlign: 'center'

        }]
        this.showCity = true
      }
      if (cityOptions.length == 1) {
        this.dadaInfo.dada_city_code = cityOptions[0].cityCode
        this.dadaInfo.city_name = this.cityName
      }
    },
    confirmCity () {
      let values = this.$refs.city_picker.getValues()
      this.cityName = values[values.length - 1].cityName
      this.showCity = false
    },
    setPostion (lng, lat) {
      this.dadaInfo.lng = lng
      this.dadaInfo.lat = lat
    },
    confirmBusiness () {
      let values = this.$refs.business_picker.getValues()
      this.dadaInfo.business_text = values[values.length - 1].text
      this.dadaInfo.business = values[values.length - 1].id
      this.showBusiness = false
    },
    submit () {
      saveDadaShop(this.dadaInfo).then(res => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .toolbar {
        height: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        background-color: #f0f2f5;
        .toolbar-item {
            font-size: .6rem;
            border: none;
            border-radius: 0;
            background-color: #f0f2f5;
        }
        .cancel-item {
            margin-left: 0.5rem;
            color: #4e545d;
        }
        .confirm-item {
            margin-right: 0.5rem;
            color: red;
        }
        .picker-header {
            color: #4e545d;
            line-height: 2rem;
            font-size:.8rem;
        }
    }
</style>
